module.exports = __webpack_public_path__ + "img/love-paws-homestay-pet-boarding-bg.c6d204f4.jpg";